import moment from 'moment';
import AppService from 'App/legacy/AppService';

export const getSignature = () => `${AppService.getSelf().name} ${moment().format('L LT')}\n\n\n`;

export const focusSignatureTextArea = (textArea: HTMLTextAreaElement, signature: string = getSignature()) => {
	textArea.selectionStart = signature.length - 2;
	textArea.selectionEnd = signature.length - 2;
	textArea.focus();
};

const insertSignatureOnRef = (textArea: HTMLTextAreaElement, onChange: (notes: string) => void) => {
	if (!textArea) {
		return;
	}
	const inputName = getSignature();
	textArea.value = inputName + textArea.value;
	focusSignatureTextArea(textArea, inputName);
	onChange(textArea.value);
};

export default insertSignatureOnRef;
